module.exports = __webpack_public_path__ + "static/media/12.dca7d6d3.jpg";